/* =========================================================================
   My Prolearning — app.js
   Countdown · reviews carousel · DCG/DSCG product filter
   · Instagram carousel · mobile drawer · scroll reveal · cart counter
   ========================================================================= */
(function () {
  "use strict";
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  let io = null; /* IntersectionObserver — declared early to avoid TDZ */

  /* ---------------------------------------------------------------- Drawer */
  const drawer = $("#mplDrawer"), scrim = $("#mplScrim");
  function setDrawer(open) {
    drawer && drawer.classList.toggle("is-open", open);
    scrim && scrim.classList.toggle("is-open", open);
    document.body.style.overflow = open ? "hidden" : "";
  }
  $("#mplBurger") && $("#mplBurger").addEventListener("click", () => setDrawer(true));
  $("#mplDrawerClose") && $("#mplDrawerClose").addEventListener("click", () => setDrawer(false));
  scrim && scrim.addEventListener("click", () => setDrawer(false));
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") setDrawer(false); });

  /* ----------------------------------------------------------- Topbar close */
  const topClose = $("#mplTopClose");
  if (topClose) {
    if (localStorage.getItem("mpl_topbar_closed") === "1") document.body.classList.add("mpl-topbar-hidden");
    topClose.addEventListener("click", () => {
      document.body.classList.add("mpl-topbar-hidden");
      localStorage.setItem("mpl_topbar_closed", "1");
    });
  }

  /* ------------------------------------------------------ Newsletter submit */
  $$("[data-newsletter]").forEach(form => {
    form.addEventListener("submit", () => {
      const input = form.querySelector("input");
      if (input && !input.checkValidity()) { input.reportValidity(); return; }
      form.classList.add("is-sent");
      if (input) input.value = "";
    });
  });

  /* ----------------------------------------------------------- Hero parallax */
  const heroMedia = $(".mpl-hero__media"), heroImg = heroMedia && heroMedia.querySelector("img");
  const reduceMo = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (heroImg && !reduceMo && window.matchMedia("(pointer:fine)").matches) {
    const hero = $(".mpl-hero");
    hero.addEventListener("mousemove", (e) => {
      const r = hero.getBoundingClientRect();
      const dx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      const dy = ((e.clientY - r.top) / r.height - 0.5) * 2;
      heroImg.style.transform = `rotateY(${dx * 6}deg) rotateX(${-dy * 6}deg) translate(${dx * 8}px, ${dy * 8}px)`;
    });
    hero.addEventListener("mouseleave", () => { heroImg.style.transform = ""; });
  }

  /* --------------------------------------------------- Reveal section heads */
  $$(".mpl-section > .mpl-wrap > .mpl-eyebrow").forEach(eb => {
    eb.classList.add("mpl-rv-head");
    const h2 = eb.nextElementSibling;
    if (h2 && (h2.tagName === "H2" || h2.classList.contains("mpl-h2"))) {
      h2.classList.add("mpl-rv-head"); h2.style.transitionDelay = ".08s";
      const lead = h2.nextElementSibling;
      if (lead && lead.classList.contains("mpl-lead")) {
        lead.classList.add("mpl-rv-head"); lead.style.transitionDelay = ".16s";
      }
    }
  });

  /* ------------------------------------------------------------- Countdown */
  /* Deterministic deadline (next Sunday 23:59:59) — identical to the DCG/DSCG
     subscription pages (mpl-offer.js), so the clock matches everywhere. */
  function deadline() {
    var n = new Date();
    var d = new Date(n.getFullYear(), n.getMonth(), n.getDate(), 23, 59, 59, 0);
    var days = (7 - d.getDay()) % 7; // 0 = Sunday
    d.setDate(d.getDate() + days);
    if (d.getTime() <= n.getTime()) d.setDate(d.getDate() + 7);
    return d.getTime();
  }
  let target = deadline();
  const cd = { d: $("#cdD"), h: $("#cdH"), m: $("#cdM"), s: $("#cdS") };
  function pad(n) { return String(n).padStart(2, "0"); }
  function tick() {
    let diff = target - Date.now();
    if (diff <= 0) { target = deadline(); diff = target - Date.now(); }
    const d = Math.floor(diff / 86400000);
    const h = Math.floor(diff % 86400000 / 3600000);
    const m = Math.floor(diff % 3600000 / 60000);
    const s = Math.floor(diff % 60000 / 1000);
    if (cd.d) cd.d.textContent = pad(d);
    if (cd.h) cd.h.textContent = pad(h);
    if (cd.m) cd.m.textContent = pad(m);
    if (cd.s) {
      const next = pad(s);
      if (cd.s.textContent !== next) {
        cd.s.textContent = next;
        cd.s.classList.remove("mpl-flip"); void cd.s.offsetWidth; cd.s.classList.add("mpl-flip");
      }
    }
  }
  if (cd.s) { tick(); setInterval(tick, 1000); }

  /* ------------------------------------------------------ Reviews carousel */
  const rTrack = $("#mplReviews");
  if (rTrack) {
    const step = () => Math.min(rTrack.clientWidth * .82, 320);
    $("#revPrev") && $("#revPrev").addEventListener("click", () => rTrack.scrollBy({ left: -step(), behavior: "smooth" }));
    $("#revNext") && $("#revNext").addEventListener("click", () => rTrack.scrollBy({ left:  step(), behavior: "smooth" }));
  }

  /* ----------------------------------------------------- Instagram carousel */
  const igTrack = $("#mplIg");
  if (igTrack) {
    const step = () => Math.min(igTrack.clientWidth * .8, 300);
    $("#igPrev") && $("#igPrev").addEventListener("click", () => igTrack.scrollBy({ left: -step(), behavior: "smooth" }));
    $("#igNext") && $("#igNext").addEventListener("click", () => igTrack.scrollBy({ left:  step(), behavior: "smooth" }));
  }

  /* ------------------------------------------------ INCLUS — showcase animé */
  const inclList = $("#mplInclList"), inclStage = $("#mplInclStage");
  if (inclList && inclStage) {
    const inclReduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const items  = $$(".mpl-incl-item", inclList);
    const panels = $$(".mpl-incl__panel", inclStage);
    const noEl   = $("#mplInclNo");
    const DUR = 5000;
    let idx = 0, timer = null, paused = false, started = false;

    function show(i, auto) {
      idx = (i + items.length) % items.length;
      items.forEach((it, k) => {
        const on = k === idx;
        it.classList.toggle("is-active", on);
        const btn = it.querySelector(".mpl-incl-item__btn");
        if (btn) btn.setAttribute("aria-expanded", on ? "true" : "false");
        const bar = it.querySelector(".mpl-incl-item__bar");
        bar.classList.remove("is-running"); void bar.offsetWidth;
        if (on && auto && !inclReduce) { bar.style.setProperty("--incl-dur", DUR + "ms"); bar.classList.add("is-running"); }
      });
      panels.forEach((p, k) => p.classList.toggle("is-active", k === idx));
      const tint = panels[idx] && panels[idx].style.getPropertyValue("--tint");
      if (tint) inclStage.style.setProperty("--stage-tint", tint);
      if (noEl) noEl.textContent = String(idx + 1).padStart(2, "0");
    }
    function schedule() {
      clearTimeout(timer);
      if (inclReduce || paused) return;
      timer = setTimeout(() => { show(idx + 1, true); schedule(); }, DUR);
    }
    items.forEach((it, k) => {
      it.querySelector(".mpl-incl-item__btn").addEventListener("click", () => { show(k, true); schedule(); });
    });
    const wrap = inclList.closest(".mpl-incl");
    if (wrap) {
      wrap.addEventListener("mouseenter", () => { paused = true; clearTimeout(timer); });
      wrap.addEventListener("mouseleave", () => { paused = false; schedule(); });
    }
    function start() { if (started) return; started = true; show(0, true); schedule(); }
    if ("IntersectionObserver" in window) {
      const so = new IntersectionObserver((es) => {
        es.forEach(e => { if (e.isIntersecting) { start(); so.disconnect(); } });
      }, { threshold: .35 });
      so.observe(inclStage);
    } else start();
  }

  /* --------------------------------------------------------- Products data */
  const F = "https://www.myprolearning.fr/cdn/shop/files/";
  const C = "https://www.myprolearning.fr/cdn/shop/collections/";
  const PRODUCTS = [
    // ---- DCG
    { exam:"DCG", ue:"UE1", tag:"Pack Réussite", title:"PACK RÉUSSITE | UE1 DCG — Fiches de révision", price:"69,00", img:F+"pack-reussite-ue1-dcg-4396391.png?v=1753111795" },
    { exam:"DCG", ue:"UE1", tag:"Pack Duo",     title:"PACK DUO | UE1 DCG — Fiches de révision",     price:"40,00", img:F+"pack-duo-ue1-dcg-6563491.png?v=1753111688" },
    { exam:"DCG", ue:"UE2", tag:"Pack Réussite", title:"PACK RÉUSSITE | UE2 DCG — Fiches de révision", price:"69,00", img:F+"pack-reussite-ue2-dcg-7884744.png?v=1753111723" },
    { exam:"DCG", ue:"UE2", tag:"Pack Trio",     title:"PACK TRIO | UE2 DCG — Fiches de révision",     price:"60,00", img:F+"pack-trio-ue2-dcg-3998311.png?v=1753111688" },
    { exam:"DCG", ue:"UE3", tag:"Pack Réussite", title:"PACK RÉUSSITE | UE3 DCG — Fiches de révision", price:"69,00", img:F+"pack-reussite-ue3-dcg-7778228.png?v=1753111882" },
    { exam:"DCG", ue:"UE3", tag:"Pack Trio",     title:"PACK TRIO | UE3 DCG — Fiches de révision",     price:"60,00", img:F+"pack-trio-ue3-dcg-4477288.png?v=1753111685" },
    { exam:"DCG", ue:"UE4", tag:"Pack Réussite", title:"PACK RÉUSSITE | UE4 DCG — Fiches de révision", price:"69,00", img:F+"pack-reussite-ue4-dcg-5708827.png?v=1753111796" },
    { exam:"DCG", ue:"UE4", tag:"Pack Duo",     title:"PACK DUO | UE4 DCG — Fiches de révision",     price:"40,00", img:F+"pack-duo-ue4-dcg-6163546.png?v=1753111687" },
    { exam:"DCG", ue:"UE6", tag:"Pack Réussite", title:"PACK RÉUSSITE | UE6 DCG — Fiches de révision", price:"69,00", img:F+"pack-reussite-ue6-dcg-5534215.png?v=1753111793" },
    // ---- DSCG
    { exam:"DSCG", ue:"UE1", tag:"Pack Réussite", title:"PACK RÉUSSITE | UE1 DSCG — Gestion juridique", price:"69,00", img:C+"ue1-dscg-gestion-juridique-fiscale-et-sociale-4567299.png?v=1753111612&width=600" },
    { exam:"DSCG", ue:"UE2", tag:"Pack Réussite", title:"PACK RÉUSSITE | UE2 DSCG — Finance",            price:"69,00", img:C+"ue2-dscg-finance-9890316.webp?v=1753111619&width=600" },
    { exam:"DSCG", ue:"UE3", tag:"Pack Réussite", title:"PACK RÉUSSITE | UE3 DSCG — Contrôle de gestion", price:"69,00", img:C+"ue3-dscg-controle-de-gestion-4504225.png?v=1753111627&width=600" },
    { exam:"DSCG", ue:"UE4", tag:"Pack Réussite", title:"PACK RÉUSSITE | UE4 DSCG — Comptabilité & audit", price:"69,00", img:C+"ue4-dscg-comptabilite-et-audit-8157680.png?v=1753111633&width=600" },
    { exam:"DSCG", ue:"UE5", tag:"Pack Réussite", title:"PACK RÉUSSITE | UE5 DSCG — Systèmes d'information", price:"69,00", img:C+"ue5-dscg-management-des-systemes-dinformation-2561289.webp?v=1753111636&width=600" },
    { exam:"DSCG", ue:"UE6", tag:"Pack Réussite", title:"PACK RÉUSSITE | UE6 DSCG — Anglais",            price:"69,00", img:C+"ue6-dscg-anglais-3330794.webp?v=1753111642&width=600" }
  ];

  const examTabs   = $$("[data-exam]");
  const ueFilter   = $("#mplUeFilter");
  const prodGrid   = $("#mplProducts");
  let curExam = "DCG", curUe = "Tous";

  const checkSvg = '<svg viewBox="0 0 24 24"><path d="M5 13l4 4L19 7"/></svg>';

  /* Real Shopify routes injected by the Liquid section (fallback to defaults). */
  const ROUTES = (window.MPL_ROUTES || {});
  const SEARCH_URL = ROUTES.search || "/search";
  function productLink(p) {
    /* Faithful port: each card links to the matching product on the real
       Shopify store via the search route (always resolves, no 404). */
    const q = [p.tag, p.ue, p.exam].join(" ");
    const sep = SEARCH_URL.indexOf("?") === -1 ? "?" : "&";
    return SEARCH_URL + sep + "q=" + encodeURIComponent(q);
  }

  function uesFor(exam) {
    const set = [];
    PRODUCTS.forEach(p => { if (p.exam === exam && !set.includes(p.ue)) set.push(p.ue); });
    return ["Tous", ...set];
  }
  function renderFilter() {
    if (!ueFilter) return;
    ueFilter.innerHTML = uesFor(curExam).map(ue =>
      `<button class="mpl-uechip${ue === curUe ? " is-active" : ""}" data-ue="${ue}">${ue}</button>`
    ).join("");
    $$("[data-ue]", ueFilter).forEach(b => b.addEventListener("click", () => {
      curUe = b.dataset.ue; renderFilter();
      if (prodGrid) {
        prodGrid.classList.add("is-swapping");
        setTimeout(() => { renderProducts(); prodGrid.classList.remove("is-swapping"); }, 200);
      }
    }));
  }
  function renderProducts() {
    if (!prodGrid) return;
    const list = PRODUCTS.filter(p => p.exam === curExam && (curUe === "Tous" || p.ue === curUe));
    prodGrid.innerHTML = list.map(p => {
      const href = productLink(p);
      return `
      <article class="mpl-product mpl-reveal">
        <a class="mpl-product__img" href="${href}"><img src="${p.img}" alt="${p.title}" loading="lazy"></a>
        <div class="mpl-product__body">
          <span class="mpl-product__tag">${p.tag} · ${p.ue} ${p.exam}</span>
          <h3 class="mpl-product__title"><a href="${href}">${p.title}</a></h3>
          <span class="mpl-product__price">€${p.price}</span>
          <div class="mpl-product__btn"><a class="mpl-btn mpl-btn--navy mpl-btn--block" href="${href}">Voir le produit</a></div>
        </div>
      </article>`;
    }).join("");
    observeReveal();
  }
  examTabs.forEach(t => t.addEventListener("click", () => {
    examTabs.forEach(x => x.classList.remove("is-active"));
    t.classList.add("is-active");
    curExam = t.dataset.exam; curUe = "Tous";
    renderFilter();
    if (prodGrid) {
      prodGrid.classList.add("is-swapping");
      setTimeout(() => { renderProducts(); prodGrid.classList.remove("is-swapping"); }, 220);
    }
  }));
  if (prodGrid) { renderFilter(); renderProducts(); }

  /* --------------------------------------------------------- Scroll reveal */
  function observeReveal() {
    if (!("IntersectionObserver" in window)) {
      $$(".mpl-reveal").forEach(el => el.classList.add("is-in")); return;
    }
    io = io || new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
    }, { threshold: .12, rootMargin: "0px 0px -8% 0px" });
    $$(".mpl-reveal:not(.is-in), .mpl-rv-head:not(.is-in)").forEach(el => io.observe(el));
  }
  observeReveal();

  /* ----------------------------------------------------------- Count-up */
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function countUp(el) {
    const target = parseFloat(el.dataset.count || "0");
    if (reduce) { el.textContent = target; return; }
    const dur = 1400, t0 = performance.now();
    function frame(now) {
      const p = Math.min((now - t0) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);            /* out-cubic */
      el.textContent = Math.round(target * eased);
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = target;
    }
    requestAnimationFrame(frame);
  }
  const countEls = $$("[data-count]");
  if (countEls.length) {
    if (reduce) {
      /* reduced motion: show final values immediately, no scroll dependency */
      countEls.forEach(el => { el.textContent = el.dataset.count || el.textContent; });
    } else if ("IntersectionObserver" in window) {
      const cio = new IntersectionObserver((entries) => {
        entries.forEach(e => { if (e.isIntersecting) { countUp(e.target); cio.unobserve(e.target); } });
      }, { threshold: .6 });
      countEls.forEach(el => cio.observe(el));
    } else countEls.forEach(countUp);
  }

  /* ------------------------------------------------------- Billing toggle */
  const bills = $$("[data-bill]");
  const amounts = $$(".mpl-plan__amount");
  const billedLabels = $$("[data-billed]");
  const planLinks = $$("[data-href-m][data-href-y]");
  /* Each plan carries its own monthly/yearly values (data-m / data-y): a plan
     without a yearly price keeps its monthly price, label and link. */
  bills.forEach(b => b.addEventListener("click", () => {
    bills.forEach(x => { x.classList.remove("is-active"); x.setAttribute("aria-selected", "false"); });
    b.classList.add("is-active"); b.setAttribute("aria-selected", "true");
    const yearly = b.dataset.bill === "y";
    amounts.forEach(a => {
      const v = yearly && a.dataset.y != null ? a.dataset.y : a.dataset.m;
      if (v == null || a.textContent === v) return;
      a.classList.remove("mpl-flip"); void a.offsetWidth; a.classList.add("mpl-flip");
      a.textContent = v;
    });
    billedLabels.forEach(l => {
      const v = yearly && l.dataset.y != null ? l.dataset.y : l.dataset.m;
      if (v != null) l.textContent = v;
    });
    planLinks.forEach(a => {
      const card = a.closest(".mpl-plan");
      const amt = card && card.querySelector(".mpl-plan__amount");
      const hasYearly = !amt || amt.dataset.y != null;
      a.href = yearly && hasYearly ? a.dataset.hrefY : a.dataset.hrefM;
    });
  }));

  /* ------------------------------------------------- Scroll progress + header */
  const progress = $("#mplProgress");
  const header = $(".mpl-header");
  const steps = $(".mpl-steps");
  const rocket = $("#mplRocket");
  const trail = $("#mplTrail");

  /* Rocket: target follows scroll, position EASES toward it via a rAF loop. */
  let curP = 0, tgtP = 0, rkActive = false, rkRAF = null, burstDone = false;
  function burst(y) {
    if (!steps) return;
    const colors = ["#E94633", "#F5B027", "#23BFD4", "#1F2A4D"];
    for (let i = 0; i < 10; i++) {
      const s = document.createElement("span");
      s.className = "mpl-spark";
      s.style.top = y + "px";
      s.style.background = colors[i % colors.length];
      const dist = 38 + Math.random() * 40;
      s.style.setProperty("--dx", ((Math.random() < 0.5 ? -1 : 1) * (10 + Math.random() * dist)).toFixed(0) + "px");
      s.style.setProperty("--dy", (-(20 + Math.random() * dist)).toFixed(0) + "px");
      s.style.setProperty("--r", (Math.random() * 200 - 100).toFixed(0) + "deg");
      s.style.animationDelay = (Math.random() * 0.1).toFixed(2) + "s";
      steps.appendChild(s);
      setTimeout(() => s.remove(), 1000);
    }
  }
  function setTarget() {
    if (!steps) return;
    const r = steps.getBoundingClientRect();
    const vh = window.innerHeight;
    let p = (vh * 0.5 - r.top) / r.height;
    tgtP = Math.max(0, Math.min(1, p));
    if (tgtP < 0.9) burstDone = false;
    const active = r.top < vh * 0.9 && r.bottom > vh * 0.1;
    if (active !== rkActive) { rkActive = active; rocket && rocket.classList.toggle("is-active", active); }
    if (trail) trail.style.height = Math.max(0, steps.offsetHeight - 80) + "px";
    if (rkActive && !rkRAF) rkRAF = requestAnimationFrame(rkLoop);
  }
  function rkLoop() {
    curP += (tgtP - curP) * 0.1;                 /* easing toward target */
    if (Math.abs(tgtP - curP) < 0.0004) curP = tgtP;
    const y = 40 + curP * (steps.offsetHeight - 80);
    if (rocket) rocket.style.transform = "translate(-50%, -50%) translateY(" + y.toFixed(1) + "px)";
    if (trail) trail.style.transform = "translateX(-50%) scaleY(" + curP.toFixed(4) + ")";
    if (curP > 0.985 && !burstDone) { burstDone = true; burst(y); }
    rkRAF = (rkActive && curP !== tgtP) ? requestAnimationFrame(rkLoop) : null;
  }

  let ticking = false;
  function onScroll() {
    const st = window.scrollY || document.documentElement.scrollTop;
    if (progress) {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      progress.style.width = (h > 0 ? (st / h) * 100 : 0) + "%";
    }
    if (header) header.classList.toggle("is-scrolled", st > 8);
    setTarget();
    ticking = false;
  }
  window.addEventListener("scroll", () => {
    if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
  }, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  onScroll();
})();
